import AddBuilding from "./AddBuilding";
import AssetOverview from "./AssetOverview";
import BuildingPassportSharedLayout from "./BuildingPassportSharedLayout";
import BuildingProfile from "./BuildingProfile";
import Certificates from "./Certificates";
import Components from "./Components";
import DynamicDashboard from "./DynamicDashboard";
import EnergyPerformance from "./EnergyPerformance";
import Execution from "./Execution";
import general from "./general";
import Login from "./Login";
import Modernization from "./Modernization";
import Portfolio from "./Portfolio";
import SharedLayout from "./SharedLayout";
import TechnicalData from "./TechnicalData";

export const en = {
  AddBuilding,
  AssetOverview,
  BuildingPassportSharedLayout,
  BuildingProfile,
  Certificates,
  Components,
  DynamicDashboard,
  EnergyPerformance,
  Execution,
  general,
  Login,
  Modernization,
  Portfolio,
  SharedLayout,
  TechnicalData,
};
